import { render, staticRenderFns } from "./OwnerEditDialog.vue?vue&type=template&id=79859355&scoped=true&"
import script from "./OwnerEditDialog.vue?vue&type=script&lang=js&"
export * from "./OwnerEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79859355",
  null
  
)

export default component.exports